import $ from "jquery";
import moment from 'moment';
import React from 'react';

export function whereBallsMove (section) {
    if (section === 1) {
        ballCircleMove($('.orange-medium-ball'), -8, 13);
        ballCircleMove($('.white-gray-ball'), 11, 19);
        ballCircleMove($('.blue-and-red-big-ball'), 22, 69);
        ballCircleMove($('.giper-white-ball'), -150, -70);
    }

    if (section === 2) {
        ballCircleMove($('.orange-medium-ball'), -9, 9);
        ballCircleMove($('.white-gray-ball'), -5, 32);
        ballCircleMove($('.blue-and-red-big-ball'), 70, 59);
        ballCircleMove($('.giper-white-ball'), -140, 10);
    }


    if (section === 3) {
        ballCircleMove($('.orange-medium-ball'), -8, 13);
        ballCircleMove($('.white-gray-ball'), 11, 19);
        ballCircleMove($('.blue-and-red-big-ball'), 18, 83);
        ballCircleMove($('.giper-white-ball'), 15, -35);
    }

    if (section === 4) {
        ballCircleMove($('.orange-medium-ball'), 6, 31);
        ballCircleMove($('.white-gray-ball'), 38, 92);
        ballCircleMove($('.blue-and-red-big-ball'), 44, 75);
        ballCircleMove($('.giper-white-ball'), -140, 20);
    }

    if (section === 5) {
        ballCircleMove($('.orange-medium-ball'), -9, 14);
        ballCircleMove($('.white-gray-ball'), 12, 20);
        ballCircleMove($('.blue-and-red-big-ball'), 22, 69);
        ballCircleMove($('.giper-white-ball'), -120, -60);
    }


    if (section === 6) {
        ballCircleMove($('.orange-medium-ball'), -8, 13);
        ballCircleMove($('.white-gray-ball'), 11, 19);
        ballCircleMove($('.blue-and-red-big-ball'), 18, 83);
        ballCircleMove($('.giper-white-ball'), 15, -35);
    }

    if (section === 7) {
        ballCircleMove($('.orange-medium-ball'), 6, 31);
        ballCircleMove($('.white-gray-ball'), 38, 92);
        ballCircleMove($('.blue-and-red-big-ball'), 44, 75);
        ballCircleMove($('.giper-white-ball'), -140, 20);
    }

    if (section === 8) {
        ballCircleMove($('.orange-medium-ball'), -9, 14);
        ballCircleMove($('.white-gray-ball'), 12, 20);
        ballCircleMove($('.blue-and-red-big-ball'), 22, 69);
        ballCircleMove($('.giper-white-ball'), -120, -60);
    }

}
// ФУНКЦИЯ ДВИЖЕНИЯ ШАРОВ

function ballCircleMove(elem, top, left) {
    $(elem).animate({
        'top': top + '%',
        'left': left + '%'
    });
}

export function isSimilarObject(obj1, obj2) {
    return (JSON.stringify(obj1) === JSON.stringify(obj2));
}

export function getHeader() {
    return  {'Authorization': 'Token ' + localStorage.id_token}
}

export function getToken() {
    return  localStorage.id_token;
}

export function isEmpty(str) {
    if (!str) {
        return false;
    } else if (str.trim().length === 0) {
        return false;
    } else {
        return true;
    }
}

export function getUTCDate(dateStr) {
    
    let date = moment(moment(dateStr), "DD/MM/YYYY");
    let dateText = 'Не указана';
    if(date.isValid()) {
        let dateNum = moment().startOf("day").diff(date, "days");
        dateText = moment(date).format("DD-MM-YYYY");
        if(dateNum === 1) dateText = 'Вчера';
        if(dateNum === 0) dateText = 'Сегодня';
        if(dateNum === -1) dateText = 'Завтра';
        if(dateNum === -2) dateText = 'Послезавтра';
    }

    return dateText;
}

export function getUTCDate2(dateStr) {
    
    let date = moment(moment(dateStr), "DD/MM/YYYY");
    let dateText = 'Не указана';
    if(date.isValid()) {
        let dateNum = moment().startOf("day").diff(date, "days");
        dateText = moment(date).format("DD.MM.YYYY");
        if(dateNum === 1) dateText = 'вчера';
        if(dateNum === 0) dateText = 'cегодня';
        if(dateNum === -1) dateText = 'завтра';
        if(dateNum === -2) dateText = 'послезавтра';
        else dateText = moment(date).format("DD.MM");
    }

    return dateText;
}

export function getFormattedTime(time) {
    if(!time || time.length < 1) return null;
    let date = new Date();
    let timeArray = time.split(':');
    date.setHours(timeArray[0])
    date.setMinutes(timeArray[1])
    //date = new Date(date + 'UTC');
    date = new Date(Date.UTC(date.getYear(), date.getMonth(), date.getDay(), date.getHours(), date.getMinutes(), date.getSeconds()));
    return moment(date).format("HH:mm");
}

export function getDateTime3(timeStart, timeEnd) {
    if((!timeStart || timeStart.length < 1) && (!timeEnd || timeEnd.length < 1)){
        return 'Время не указана'
    }
    
    let start = (timeStart && getFormattedTime(timeStart)) || 'не указано'
    let end = (timeEnd && getFormattedTime(timeEnd)) || 'не указано'
    return `с ${start}, до ${end}`;
}

export function getDateTime(date, time) {
    let now = moment();
    let theDate = moment(new Date(date), "DD/MM/YYYY");
    let theTime = moment(time, "HH:mm");
    let isDate = theDate.isValid();
    let isTime = theTime.isValid();

    if(!isDate) {
        theDate = moment(now, "DD/MM/YYYY");
    }

    if(!isTime) {
        theTime = moment(now, "HH:mm");
    }

    let dateTime = new Date(theDate);
    dateTime.setHours(theTime.get("hour"));
    dateTime.setMinutes(theTime.get("minute"));
   
    let formattedDateTime = moment(dateTime, "DD/MM/YYYY HH:mm");

    return {
        isDate: isDate,
        isTime: isTime,
        dateTime: formattedDateTime,
    }
}

export function UTCToLocal(date) {
    date = new Date(date);
    if(!moment(date).isValid()) return false;

    var newDate = new Date(date.getTime()+date.getTimezoneOffset()*60*1000);

    var offset = date.getTimezoneOffset() / 60;
    var hours = date.getHours();

    newDate.setHours(hours - offset);

    //return newDate;   
    return moment(newDate, 'DD/MM/YYYY HH:mm');
}


export function localToUTC(dateTime) {
   // let UTCDate = dateTime.utc().format('YYYY-MM-DD')
    if(!moment(dateTime, "DD/MM/YYYY HH:mm").isValid()) return false;

    let UTCDateTime = moment(dateTime).utc().format('DD/MM/YYYY HH:mm');
    return moment(UTCDateTime, "DD/MM/YYYY HH:mm");
}




//ORDER INFO

export function getExamplesList(images) {
    if(!images.length) {
        return <div>Примеры работ не прикреплены к заказу</div>
    }

    return images.map((item, index) =>
        <img className="examples__image" key={index} src={`${item.image}`} />
    )
}

export function getExamplesList2(example) {
    if(!example && !example.images && !example.videos) {
        return <div>Примеры работ не прикреплены к заказу</div>
    }

    let results = [
        ...example.images,
        ...example.videos
    ]

    return results.map((object, index) => {
        if(object.image) return <img className="examples__image" key={index} src={`${object.image}`} />
        if(object.video) return <video key={index} src={object.video} width="110" height="95" controls="controls"></video>
        return;
    })
}

export function getObjectType(object) {
    if(!object) return false;
    let type = object.object_type && object.object_type.title || 'Тип не указан';
    let title = object.title || '';
    let text = type += (title.length) ? ", " + title : ""

    return <li>{text}</li>
}

export function getMethodType(method) {
    if(!method || !method.order_method || !method.order_method.method_type) return false;

    let shootingText = (method.order_method.method_type.is_video)
        ? 'Продолжительность съемки ' + method.video_mins_ordered + ' мин.'
        : 'Количество кадров ' + method.photos_ordered + ' шт.';

    let desc = method.order_method.method_type.title || 'Метод не указан';

    return <li>{`${desc}, ${shootingText}`}</li>
}

export function getMethodValue(method) {
    if(!method) return false;

    return <li>{method.title || 'Метод съемки не указан'}</li>
}

export function getMethodDescription(method) {
    if(!method || !method.content || method.content === "") return false;
    return <li>{`Описание метода - ${method.content}`}</li>
}

export function getMethodMeasure(method) {
    if(!method || !method.measure || !method.measure.title || method.measure.title === "") return false;
    return <li>{`Инструмент - ${method.measure.title}`}</li>
}

export function getContent(content) {
    return <li>{`Примечание к объекту: ${content || 'нет примечания'}`}</li>
}



export function getTestDateTime() {
    const {
        order_date_at,
        order_time_at,
        order_time_end_at
    } = this.state;

    let theDate = moment(order_date_at, "DD/MM/YYYY");
    let now = moment();
    let startTime = moment(order_time_at, "HH:mm");
    let endTime = moment(order_time_end_at, "HH:mm");
    let isDate = theDate.isValid();
    let isStartTime = startTime.isValid();
    let isEndTime = endTime.isValid();

    if(!isDate) {
        theDate = moment(now, "DD/MM/YYYY");
    }

    if(!isStartTime) {
        startTime = moment(now, "HH:mm");
    }

    if(!isEndTime) {
        endTime = moment(now, "HH:mm");
    }

    let dateStart = new Date(theDate);
    let dateEnd = new Date(theDate);
    dateStart.setHours(startTime.get("hour"));
    dateStart.setMinutes(startTime.get("minute"));
    dateEnd.setHours(endTime.get("hour"));
    dateEnd.setMinutes(endTime.get("minute"));
    let lastDateStart = moment(dateStart, "DD/MM/YYYY HH:mm");
    let lastDateEnd = moment(dateEnd, "DD/MM/YYYY HH:mm");

    return {
        isDate: isDate,
        isStartTime: isStartTime,
        isEndTime: isEndTime,
        startDate: lastDateStart,
        endDate: lastDateEnd,
    }
}

export const orderStatusesObj = {
    7: 'Арбитраж',
    8: 'Претензия',
    0: 'Черновик',
    1: 'Размещен ',
    2: 'Поиск исполнителя',
    3: 'На исполнении', //'На исполнении ',
    4: 'Ожидает приемки ',
    5: 'Выполнен',
    6: 'Завершен'
}

export function getMessageByErrorStatus(status) {
    switch(status) {
        case 500:
            return {detail: 'Внутренняя ошибка сервера', status: 500}
        case 502:
            return {detail: 'Проблема с доступом к базе', status: 502}
        case 401:
            return {detail: 'Вы не авторизованы', status: 401}
        case 400:
            return {detail: 'Исправьте ошибки', status: 400}
        default:
            return 'Ошибка сервера';
    }
}

export function getRadius(radius, emptyText = 'Радиус не указан') {
    if(!radius) return emptyText;
    let text = '';

    function lastText(txt) {
        if(txt == 0) return '';
        let dp = '';
        if(txt > 1 && txt < 6) dp = 'а'
        if(txt > 5) dp = 'ов'
        if(!txt) return '';
        return `${txt} метр${dp}`;
    }

    if(radius >= 1000) {
        let newInt = Math.floor(radius/1000);
        let newFloat = (radius%1000).toFixed(0);
        if(newFloat) {
            text = `${newInt} км. ${text = lastText(newFloat)}`;
        }
        else text = `${newInt} км.`;
    }
    else {
        text = lastText(radius);
    }

    return `${text}`;
}

export function myToString(str) {
    if(!str) return '';
    return str.toString().toLowerCase().trim();
}

export function getTimeZone() {
    var offset = new Date().getTimezoneOffset(), o = Math.abs(offset);
    return (offset < 0 ? "+" : "-") + ("00" + Math.floor(o / 60)).slice(-2) + ":" + ("00" + (o % 60)).slice(-2);
}


// WEBPACK FOOTER //
// ./src/helper.js